<template>
  <div class="r-under-order">
    <!-- <div class="status common-hover" @click="changeTip"><div>Tip name</div></div> -->
    <div class="common-flex common-justify-between common-align-center">
      <Checkbox
        @on-change="changeCheck"
        :true-value="1"
        :false-value="0"
        v-model="config.check"
      ></Checkbox>
      <div style="margin:0 10px">{{ index + 1 }}</div>

      <div class="product">
        <img :src="config.clothUrl" alt="" />
        <div class="product-name">
          <div>{{ config.orderZhName }}</div>
        </div>
      </div>
      <div
        class="product-code common-flex common-direction-column common-justify-center"
      >
        <Poptip
          @on-popper-show="clickCode(config)"
          word-wrap
          width="200"
          :content="valuation"
          class="priceTip"
        >
          <div class="code common-hover" :style="[!config.deliveryDate&&config.planDeliveryDate&&config.status!=10370&&dateDiff(config.planDeliveryDate)>=5?{color: '#F39C12'}:'']">{{ config.orderCode }}<div class="attr" v-if="config.cusOrderCode">{{ config.cusOrderCode }}</div></div>
        </Poptip>
        <!-- <div class="code">{{ config.orderCode }}</div> -->
        <div class="attr">
          <span v-if="config.clothZhName">{{ config.clothZhName }} |</span>
          <span v-if="config.fabric">{{ config.fabric }} |</span>
          <span v-if="config.pubDate">{{ config.pubDate }}</span>
        </div>
        <div class="details">
          <span class="common-hover" @click="details">Details</span>
          <span class="common-hover" @click="handleBuyAgain">{{
            $t("cart.buyAgain")
          }}</span>
          <span
            class="common-hover"
            v-if="
              config.status == '10030' ||
                config.status == '10371' ||
                config.status == '206012'
            "
            @click="cancel"
          >
            | Cancel</span
          >
        </div>
      </div>
      <!-- <div
        class="product-code common-flex common-direction-column common-justify-center"
      >
        <div class="code">{{config.orderCode}}</div>
        <div class="attr">
          <span>{{config.clothCategoryName}} </span>
          |
          <span>{{$t('underProduction.Qty')}}:{{config.amount}}</span>
          </div>
        <div class="details"> <span class="common-hover"  style="padding-right:5px;margin-right:5px;border-right:1px solid #0a4dcc" @click="checkOptions">{{$t('underProduction.details')}} </span>  <span class="common-hover" @click="reorder">{{$t('underProduction.reorder')}}</span> </div>
      </div> -->

      <div
        class="
          product-cate
          common-justify-center common-flex common-align-center common-column
        "
      >
        <div>
          <Tooltip :content="config.sizeCategoryName" placement="top">
            <div
              v-if="config.sizeCategoryId == 10054"
              class="iconfont iconbiaozhunhao"
            ></div>
            <div
              v-if="config.sizeCategoryId == 10053"
              class="iconfont iconchengyi"
            ></div>
            <div
              v-if="config.sizeCategoryId == 10052"
              class="iconfont iconjingti"
            ></div>
          </Tooltip>
          <div style="display:inline-block">{{ config.custName || "" }}</div>
        </div>
        <div v-if="config.amount == 1 && config.addProduct == 1" style="margin: 10px">
          <Checkbox :true-value="1" :false-value="0" v-model="config.addProduct" disabled>{{ $t("saveItems.add") }}</Checkbox>
        </div>
      </div>
      <div class="product-total">
        {{ config.unitPrice }} x {{ config.amount }}
      </div>
      <div>
        <div
          class="common-flex common-align-center"
          style="margin-bottom:6px"
        >
          <div class="product-title">Finished date</div>
          <div class="product-date">{{ config.planDeliveryDate?config.planDeliveryDate:"-- / -- / ----" }}</div>
        </div>
        <div
          v-if="config.deliveryDate"
          class="common-flex common-align-center"
          style="margin-bottom:6px"
        >
          <div class="product-title">Delivery Date</div>
          <div class="product-date">{{ config.deliveryDate }}</div>
        </div>
        <div
          v-if="config.waybillNo"
          class="common-flex common-align-center"
          style="margin-bottom:6px"
        >
          <div class="product-title">AWB #</div>
          <div class="product-date" style="color: #0a4dcc;">{{ config.waybillNo }}</div>
        </div>
        <!-- <div class="product-total"><span v-if="config.pubDate">{{$t('underProduction.pubDate')}}：{{config.pubDate }} </span> <span v-if="config.deliveryDate">/{{$t('underProduction.deliveryDate')}}：{{config.deliveryDate}}</span> </div> -->
        <!-- <div class="product-total"><span v-if="config.pubDate">{{$t('underProduction.pubDate')}}：{{config.pubDate }} </span> <span v-if="config.deliveryDate">/{{$t('underProduction.deliveryDate')}}：{{config.deliveryDate}}</span> </div> -->
        <!-- <div class="product-total"><span v-if="config.pubDate">{{$t('underProduction.pubDate')}}：{{config.pubDate }} </span> <span v-if="config.deliveryDate">/{{$t('underProduction.deliveryDate')}}：{{config.deliveryDate}}</span> </div> -->
      </div>
      <div
        class="product-status common-flex common-align-center common-justify-center"  @click='showMsg(config)'
      >
        <div
          :style="[
            config.status == 10030
              ? { backgroundColor: '#D87508' }
              : config.status == 10369
              ? { backgroundColor: '#ed4014' }
              : config.status == 10370
              ? { backgroundColor: '#909399' }
              : { backgroundColor: '#0a4dcc' }
          ]"
          class="radio"
        ></div>
        <div
          :style="[
            config.status == 10030
              ? { color: '#D87508' }
              : config.status == 10369
              ? { color: '#ed4014' }
              : config.status == 10370
              ? { color: '#909399' }
              : { color: '#0a4dcc' }
          ]"
        >
          {{ config.statusName }}
        </div>
      </div>
      <!-- <div class="product-price">$1 600,00</div> -->
      <!-- <div class="product-status common-flex common-align-center common-justify-center">
        <div class="radio"></div>
        <div>Product</div>
      </div> -->
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import moment from "moment";
export default {
  name: "r-under-order",
  data() {
    return {
      check: false,
      valuation: ""
    };
  },
  props: {
    config: Object,
    index: Number
  },
  methods: {
    ...mapActions([
      "getOrderFormulaAction" //订单号计价公式
    ]),
    // 点击
    clickCode(e) {
      // getOrderFormulaAction
      let that=this;
      this.valuation = "loading...";
      this.getOrderFormulaAction(e.orderId).then(res => {
        this.valuation = "";
        res.data.map(item => {
          this.valuation += item.categoryName + ":\n" + item.formula + ";\n\n";
        });
        if(undefined!==e.flPrice){
          const flInfoString = JSON.parse(e.flInfo)
            .map(item => `${item.flCode}(${item.flPrice})`)
            .join(' + ');
          this.valuation += that.$t('materialCostDetail',{flPrice:e.flPrice,flInfo:flInfoString})
          this.valuation += that.$t('materialCost',{totalPrice:e.price,flPrice:e.flPrice,cloth:e.clothZhName,clothPrice:(e.price.substring(1)-e.flPrice).toFixed(2)})
        }
      });
    },
    // 修改备注标签
    // changeTip(){
    //   this.$emit('changeTip')
    // },
    // 重新排序
    reorder() {
      this.$emit("reorder");
    },
    //检查选项
    checkOptions() {
      this.$emit("checkOptions", this.config);
    },
    // 支票收入
    checkMasurement() {
      this.$emit("checkMasurement");
    },
    // 是否选中
    changeCheck(e) {
      this.$emit("changeCheck", e, this.config, this.index);
    },
    // 取消弹框
    cancel() {
      this.$emit("cancel", this.config);
    },
    // 紧急顶大弹框
    urgent() {
      this.$emit("urgent");
    },
    // 订单详情
    details() {
      this.$emit("details", this.config);
    },
    // 再次购买
    handleBuyAgain() {
      this.$emit("buyagain", this.config);
    },
    // 计算时间差
    dateDiff(date) {
      let start = moment(date, 'DD/MM/YYYY');
      let end = moment();
      return end.diff(start,'day');
    },
    //弹出错误提示
    showMsg(item){
      if(item.status != 10369){
        return;
      }
      this.$Notice.warning({
        title: item.orderCode,
        desc:item.blError,
        duration: 8
      });
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.r-under-order {
  // width: 1140px;
  margin: 0 auto;
  padding: 20px 10px 20px;
  border-bottom: 1px solid #f0f0f0;
  // .status {
  //   width: 52px;
  //   height: 20px;
  //   line-height: 20px;
  //   background: #fbf1e6;
  //   font-size: 10px;
  //   font-weight: 400;
  //   text-align: right;
  //   color: #d87508;
  //   position: relative;
  //   > div {
  //     transform: scale(0.83);
  //   }
  // }
  .status::after {
    content: "";
    position: absolute;
    width: 0;
    height: 0;
    border-top: 20px solid #fbf1e6;
    border-right: 20px solid transparent;
    right: -20px;
    top: 0;
  }
  .product {
    width: 125px;
    height: 76px;
    position: relative;
    margin-right: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    img {
      width: 76px;
      height: auto;
      object-fit: cover;
      object-position: center center;
      cursor: pointer;

    }
  }
  .product-name {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 76px;
    height: 15px;
    line-height: 15px;
    background: rgba(8, 25, 56, 0.5);
    color: #fff;
    text-align: center;

    > div {
      font-size: 12px;
      transform: scale(0.83);
    }
  }
  .product-code {
    width: 350px;
    text-align: left;
    .code {
      font-size: 14px;
      font-weight: 600;
      color: #081938;
      line-height: 16px;
    }
    .attr {
      font-size: 12px;
      font-weight: 400;
      color: #081938;
      line-height: 14px;
      margin: 5px 0;
    }
    .details {
      font-size: 12px;
      font-weight: 400;
      text-decoration: underline;
      color: #0a4dcc;
      line-height: 14px;
    }
  }
  .product-cate {
    width: 360px;
    opacity: 1;
    font-size: 14px;
    font-family: Roboto, Roboto-Condensed;
    font-weight: Condensed;
    // text-align: left;
    color: #081938;
    line-height: 16px;
    letter-spacing: 1px;
    .iconjacket {
      margin-right: 9px;
    }
  }
  .product-total {
    width: 200px;
    font-size: 14px;
    font-weight: 400;
    text-align: center;
    color: #081938;
    line-height: 16px;
  }
  .product-title {
    width: 120px;
    font-size: 12px;
    font-family: Roboto, Roboto-Regular;
    font-weight: 400;
    text-align: right;
    color: #081938;
    line-height: 14px;
  }
  .product-date {
    width: 130px;
    height: 24px;
    background: #f8f8f8;
    font-size: 12px;
    font-family: Roboto, Roboto-Regular;
    font-weight: 400;
    text-align: left;
    line-height: 24px;
    color: #081938;
    margin-left: 8px;
    padding: 0 8px;
  }
  //   .product-price {
  //     width: 220px;
  //     font-size: 14px;
  //     font-weight: 600;
  //     text-align: right;
  //     color: #081938;
  //     line-height: 16px;
  //   }
  .product-status {
    width: 200px;
    text-align: right;
    color: #0a4dcc;
    .radio {
      width: 4px;
      height: 4px;
      border-radius: 50%;
      background: #0a4dcc;
      margin-right: 6px;
    }
  }
}
.priceTip /deep/ .ivu-poptip-popper {
  width: 400px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/r-under-order.vue